import React from "react";

import { LabeledField, SectionCard, Stack, TextInput, ToggleSwitch } from "shared/ui";
import { TariffVariant } from "modules/settings/models";

import { PAYMENT_TYPES } from "features/MenuSettings/constants";
import { useMenuSettingsContext } from "features/MenuSettings/context";

// Наличные доступны с базового тарифа, онлайн-оплаты — с продвинутого.
const TARIFF_BY_PAYMENT: Record<string, TariffVariant> = {
    Offline: "Basic",
    CloudPaymentsCheckout: "Advanced",
    SBPTochka: "Advanced",
};

export const PaymentsTab = () => {
    const { payments, hasExternalIntegration, ensureTariff } = useMenuSettingsContext();

    return (
        <>
            {PAYMENT_TYPES.map((item) => {
                const settings = payments.paymentByType[item.type];

                return (
                    <SectionCard
                        key={item.type}
                        title={item.title}
                        description={item.description}
                    >
                        <Stack>
                            <ToggleSwitch
                                checked={settings.isEnabled}
                                label="Включить способ оплаты"
                                onChange={(checked) => {
                                    if (!ensureTariff(TARIFF_BY_PAYMENT[item.type])) return;
                                    payments.setEnabled(item.type, checked);
                                }}
                            />

                            {hasExternalIntegration && (
                                <LabeledField
                                    label="ID способа оплаты в iiko"
                                    hint="Заказ уйдёт в iiko с этим способом оплаты"
                                >
                                    <TextInput
                                        value={settings.externalId}
                                        onChange={(value) =>
                                            payments.setExternalId(item.type, value)
                                        }
                                    />
                                </LabeledField>
                            )}
                        </Stack>
                    </SectionCard>
                );
            })}
        </>
    );
};
